import { render, staticRenderFns } from "./notifyRenderer.vue?vue&type=template&id=562c27f6&scoped=true"
import script from "./notifyRenderer.vue?vue&type=script&lang=js"
export * from "./notifyRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562c27f6",
  null
  
)

export default component.exports